import Player from "./Player";
import SidePanel from "./SidePanel";
import {
  useGetVideoQuery,
  useGetVideosQuery,
} from "../../../features/videos/videosApi";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Course() {
  const { videoId } = useParams();
  const [singleVideoId, setSingleVideoId] = useState("");
  const { data: videos, isLoading, isError } = useGetVideosQuery() || {};

  const {
    data: singleVideo,
    isLoading: singleVideoLoading,
    isError: singleVideoError,
  } = useGetVideoQuery(singleVideoId) || {};

  useEffect(() => {
    if (videoId) setSingleVideoId(videoId);
  }, [videoId]);

  // render side panel
  let sidePanel = null;
  let player = null;
  if (isLoading)
    sidePanel = (
      <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
        Loading...
      </div>
    );
  if (!isLoading && isError)
    sidePanel = (
      <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
        Error
      </div>
    );
  if (!isLoading && !isError && videos?.length === 0)
    sidePanel = (
      <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
        No video
      </div>
    );
  if (!isLoading && !isError && videos?.length > 0)
    sidePanel = <SidePanel videos={videos} />;

  //video player render
  if (singleVideoLoading)
    player = (
      <div className="col-span-full w-full space-y-8 lg:col-span-2">
        loading...
      </div>
    );
  if (!singleVideoLoading && singleVideoError)
    player = (
      <div className="col-span-full w-full space-y-8 lg:col-span-2">
        Error..
      </div>
    );
  if (!singleVideoLoading && !singleVideoError && singleVideo.length)
    player = <Player video={singleVideo[0]} />;

  if (!singleVideoLoading && !singleVideoError && singleVideo?.id)
    player = <Player video={singleVideo} />;

  return (
    <div className="grid grid-cols-3 gap-2 lg:gap-8">
      {player}
      {sidePanel}
    </div>
  );
}
